<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <div id="dragon-home"></div>
    <div class="home__scroll">
      <div id="scroll-home" :class="{ 'scale-y': instructionsClicked }"></div>
      <div class="home__scroll__start" :class="{ 'fade-out': instructionsClicked }">
        <h1 class="home__scroll__start--title">Expanded Forms Dragon Edition!</h1>
        <button class="home__scroll__start--button" @click="clickInstructions">Instructions</button>
      </div>
      <div v-show="instructionsClicked" class="home__scroll__alternate">
        <p class="home__scroll__alternate--instructions">
          We will show you some exercises in expanded form, you need to choose the correct standard form for each one!
          Good luck!
        </p>
        <button class="home__scroll__alternate--button" @click="clickStart">Start</button>
      </div>
      <!-- @click fadeOut scroll block -> scaleY 'scroll-home' & fadeIn instructions + Start button. -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  computed: {
    ...mapGetters({
      homeScreenStatus: 'expandedForm/homeScreenStatus',
    }),
  },
  data: () => ({
    instructionsClicked: false,
  }),
  methods: {
    ...mapActions({
      homeClickStart: 'expandedForm/homeClickStart',
    }),
    clickInstructions() {
      sounds.globalButton.play();
      this.instructionsClicked = !this.instructionsClicked;
    },
    clickStart() {
      sounds.globalButton.play();
      this.homeClickStart();
      this.instructionsClicked = false;
    },
  },
  watch: {
    homeScreenStatus: state => {
      if (state) {
        sounds.expandedFormSleepingDragon.play();
      } else {
        sounds.expandedFormSleepingDragon.pause();
      }
    },
  },
  mounted() {
    sounds.expandedFormScrollHome.play();
    sounds.expandedFormSleepingDragon.play();
    const dragonHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('dragon-home'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/expanded_form/animations/dragon_home.json',
    });
    const scrollHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('scroll-home'),
      renderer: 'svg',
      loop: false,
      path: '/assets/practices/expanded_form/animations/scroll.json',
    });
    dragonHomeAnimation.play();
    scrollHomeAnimation.play();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;

  &__scroll {
    @include flex-center;
    animation: scroll-animation 3s forwards;
    -moz-animation: scroll-animation 3s forwards;
    -webkit-animation: scroll-animation 3s forwards;
    flex-direction: column;
    height: 50vh;
    position: absolute;
    right: -1.5%;
    width: 50vw;

    &__start,
    &__alternate {
      @include flex-center;
      animation: fade-in 0.5s forwards;
      flex-direction: column;
      opacity: 0;
      position: absolute;
      transform: translate(4%, -5%);
      width: 85%;
      z-index: 2;

      &--button {
        background-color: $expanded-form-color-main;
        border: none;
        border-radius: 50vh;
        color: $expanded-form-color-alt-third;
        font-size: 4vw;
        padding: 0.25em 0.75em;
      }
    }

    &__start {
      animation-delay: 3s;

      &--title {
        font-size: 4vw;
        text-align: center;
      }
    }

    &__alternate {
      &--instructions {
        animation: fade-in 0.5s forwards;
        font-size: 2.5vw;
        margin-bottom: 0.5em;
        text-align: center;
      }
    }
  }
}

#dragon-home,
#scroll-home {
  position: absolute;
}

#dragon-home {
  height: 50vw;
  transform: translateX(-50%);
  width: 50vw;
}

#scroll-home {
  width: 100%;
}

.fade-out {
  animation: fade-out 0.5s forwards;
}

.scale-y {
  animation: scale-y 1s forwards;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes scale-y {
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(1.3);
  }
}

@keyframes scroll-animation {
  0% {
    transform: translate(-20vw, -50vh) rotate(-15deg);
  }
  19% {
    transform: translate(-10vw, -5vh) rotate(-15deg);
  }
  40% {
    transform: translate(0vw, -30vh) rotate(10deg);
  }
  50% {
    transform: translate(0, 0) rotate(0deg);
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}

// Safari Browsers Only Fix

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .home {
      &__scroll {
        animation: none;
        -moz-animation: none;
        -webkit-animation: none;
      }
    }
  }
}
</style>
